import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import { CircularProgress } from '@mui/material'

const style = {
    maxWidth: 'none',
    minWidth: 'none',
    zIndex: '999999999'
};

const customContentStyle = {
    width: '145px',
    maxWidth: 'none',
    display: 'flex',
    alignItems: "center",
    flexDirection: "column",
    padding: "20px"
};

class DialogLoading extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { open = false, message } = this.props || {};

        return (
            <div>
                <Dialog
                    // modal={true}
                    open={open}
                    // contentStyle={customContentStyle}
                    sx={style}
                >
                    <div className="loading" style={{ ...customContentStyle }}>
                        <CircularProgress size={50} thickness={5} />
                        <br />
                        <h4 className="text-center">{message || "Loading"}</h4>

                    </div>
                </Dialog>
            </div>);
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps() {
    return {
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DialogLoading);
